import React from 'react';
import { Card, Row, Col, InputGroup, FormControl, Form } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

const SearchAndFilters = ({
  search, setSearch,
  statusFilter,
  setStatusFilter,
  itemsPerPage,
  setItemsPerPage,
  startIndex,
  totalItems,
  searchPlaceholder = 'Search...'
}) => {
  return (
    <Card className="mb-4 border-0 shadow-sm">
      <Card.Body>
        <Row className="g-3 align-items-center">
          <Col md={5}>
            <InputGroup>
              <InputGroup.Text className="bg-light border-0">
                <FaSearch />
              </InputGroup.Text>
              <FormControl
                placeholder={searchPlaceholder}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </InputGroup>
          </Col>
          <Col md={3}>
            <Form.Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Statuses</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </Col>
          <Col md={2}>
            <Form.Select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
            >
              <option value={10}>10 / page</option>
              <option value={25}>25 / page</option>
              <option value={50}>50 / page</option>
              <option value={100}>100 / page</option>
            </Form.Select>
          </Col>
          <Col md={2} className="text-muted text-end small">
            Showing {startIndex + 1}-{Math.min(startIndex + itemsPerPage, totalItems)} of {totalItems}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SearchAndFilters;